import { AbstractControl } from '@angular/forms';

export function IDFormatLegalRepresentativeValidator(control: AbstractControl) {
  if (!control.value || !control.parent) {
    return null;
  }
  const idType = control.parent.get('documentType')?.value;

  if (idType === 'other' || !idType) {
    return null;
  }

  if (idType === 'national id') {
    const numbersOnly = new RegExp(/^-?(0|[0-9]\d*)?$/).test(control.value);
    if (!numbersOnly) {
      return {
        numbersOnly: true,
      };
    }
  } else if (idType === 'foreigner card') {
    const numbersOnly = new RegExp(/^-?(0|[0-9]\d*)?$/).test(control.value);
    if (!numbersOnly) {
      return {
        numbersOnly: true,
      };
    }
  }
  return null;
}
